import { useState } from "react";
import { useLocation } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GUIDES } from "@/lib/guides";

export const GuideSteps = ({ guide }) => (
  <div>
    <p className="mb-4 text-sm text-slate-400">{guide.goal}</p>
    <ol className="space-y-3">
      {guide.steps.map((s, i) => (
        <li key={i} className="flex gap-3 text-sm text-slate-200">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#D4AF37]/20 text-xs font-semibold text-[#F5D77F]">{i + 1}</span>
          <span className="pt-0.5">{s}</span>
        </li>
      ))}
    </ol>
  </div>
);

export const GuideButton = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const guide = GUIDES[pathname.replace(/\/$/, "")];
  if (!guide) return null;
  return (
    <>
      <Button variant="ghost" size="sm" className="text-[#F5D77F] hover:bg-[#D4AF37]/10" onClick={() => setOpen(true)} data-testid="page-guide-btn">
        <BookOpen className="mr-1 h-4 w-4" /> Como usar esta página
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] overflow-y-auto border-[#1E3A6E] bg-[#0F2242] text-white" data-testid="page-guide-dialog">
          <DialogHeader><DialogTitle>Passo a passo: {guide.title}</DialogTitle></DialogHeader>
          <GuideSteps guide={guide} />
        </DialogContent>
      </Dialog>
    </>
  );
};
